import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiUrl } from '@brand-lolly/app/_services/base-api-urls';
import { catchError, Observable, of } from 'rxjs';
import {
	ApiKey,
	ApiKeyCreated,
	CreateApiKeyRequest
} from '@brand-lolly/app/billing/types/api-key.types';

export interface IApiKeyService {
	list(): Observable<ApiKey[]>;
	create(request: CreateApiKeyRequest): Observable<ApiKeyCreated>;
	rotate(keyId: number): Observable<ApiKeyCreated>;
}

/**
 * Brand self-service management of public-API keys. Uses the normal brand
 * session (the auth interceptor attaches the JWT); the issued key then
 * authenticates against the separate public API.
 */
@Injectable({ providedIn: 'root' })
export class ApiKeyService implements IApiKeyService {
	private readonly url = `${BaseApiUrl.SocialMessengerPython}api-keys`;

	constructor(private http: HttpClient) {}

	/** Existing keys (secret never included). Degrades to an empty list. */
	list(): Observable<ApiKey[]> {
		return this.http
			.get<ApiKey[]>(this.url)
			.pipe(catchError(() => of<ApiKey[]>([])));
	}

	/** Issue a new key. The full token is returned exactly once. */
	create(request: CreateApiKeyRequest): Observable<ApiKeyCreated> {
		return this.http.post<ApiKeyCreated>(this.url, request);
	}

	/** Replace a key (same name + scopes), revoking the old one. Token once. */
	rotate(keyId: number): Observable<ApiKeyCreated> {
		return this.http.post<ApiKeyCreated>(`${this.url}/${keyId}/rotate`, {});
	}
}
